var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserDuotone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.22 2.63996C9.98002 2.15996 7.22002 4.91996 7.70002 8.15996C8.06002 10.2 9.62002 11.88 11.66 12.12C14.9 12.6 17.66 9.83996 17.18 6.59996C16.94 4.67996 15.26 2.99996 13.22 2.63996Z",
    fill: "#E0E0EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 13.3198H11.9C8.42 13.3198 5.3 15.4798 3.98 18.7198L3.74 19.3198C3.26 20.5198 4.22 21.7198 5.42 21.7198H19.46C20.66 21.7198 21.62 20.5198 21.14 19.3198L20.9 18.7198C19.7 15.4798 16.58 13.3198 13.1 13.3198Z",
    fill: "#C6C6D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDuotone);
export default __webpack_public_path__ + "static/media/user-duotone.0391771afadc0edce1d92e80e96e55ab.svg";
export { ForwardRef as ReactComponent };